import React from "react";
import Barcode from "react-barcode";
import { AddCommaNumber } from "../../helpers/Utils";

class ComponentToPrint extends React.Component {
  componentWillUnmount() {
    document.body.classList.remove("noscroll");
  }

  render() {
    let { items, selectedItems } = this.props;
    const itemsPrint =
      selectedItems && selectedItems.length > 0
        ? items.filter((item) => selectedItems.includes(item.id))
        : null;

    return (
      <div
        className="invoice-react invoice-contents"
        id="print-area-container"
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "90mm",
          margin: 0,
          padding: 0,
        }}
      >
        {itemsPrint &&
          itemsPrint.map((item, index) => (
            <div
              key={item.id || index}
              className="label-item"
              style={{
                width: "45mm",
                height: "30mm",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "1mm",
                boxSizing: "border-box",
                pageBreakInside: "avoid",
              }}
            >
              {item.barcode ? (
                <Barcode
                  value={item.barcode}
                  width={1.2}
                  height={25}
                  displayValue={true}
                  fontSize={8}
                  margin={0}
                  textMargin={1}
                  format="CODE128"
                />
              ) : (
                <span style={{ fontSize: "8pt", color: "#999" }}>
                  No barcode
                </span>
              )}
              <p
                className="w-100 mb-0 text-center"
                style={{
                  fontSize: "7pt",
                  lineHeight: "1.1",
                  wordBreak: "break-word",
                  marginTop: "1mm",
                  margin: 0,
                }}
              >
                {item.name} - {AddCommaNumber(item.price)}đ
              </p>
            </div>
          ))}
      </div>
    );
  }
}

export default ComponentToPrint;
